import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';

import { ValidationMessageService } from '../../../services/validation-message.service';

import { ErrorClassWhenInvalidModule } from '../../../directives/error-class-when-invalid/error-class-when-invalid.module';
import { FormMessagesModule } from '../../shared/form-messages/form-messages.module';
import { StringValidatorsModule } from '../../../directives/validators/string/string-validators.module';
import { LoginComponent } from './login.component';
import { Confirm2faCodeModule } from '../../app-layout/settings/user/security/confirm-2fa-code/confirm-2fa-code.module';

@NgModule({
    imports: [
        // Shared
        SharedModule,
        // Dependencies
        ErrorClassWhenInvalidModule,
        FormMessagesModule,
        StringValidatorsModule,
        Confirm2faCodeModule,
        // Routing
        RouterModule.forChild([
            {
                path: '',
                component: LoginComponent,
            },
        ]),
    ],
    declarations: [LoginComponent],
    providers: [
        ValidationMessageService,
    ],
})
export class LoginModule
{
}
